import { useEffect } from "react";
import { Outlet } from "react-router";
import { ActivityLogging } from "./components/ActivityLogging";
import SystemMessages from "./components/SystemMessages";
import { AppProvider } from "./contexts/AppContext";
import { AuthProvider } from "./contexts/AuthContext";
import { CustomerProvider } from "./contexts/CustomerContext";
import { RunProvider } from "./contexts/RunContext";
import { SystemMessagesProvider } from "./contexts/SystemMessagesContext";
import { ThemeModeProvider } from "./contexts/ThemeModeContext";
import { parquetWorkerManager } from "./utils/parquet-worker-manager";

function App() {
  // Global cleanup on app unmount to prevent memory leaks
  useEffect(() => {
    return () => {
      // Clean up parquet worker
      parquetWorkerManager.terminate();
    };
  }, []);

  // Warm the parquet worker POOL eagerly at app mount so each worker's WASM
  // fetch+compile starts immediately and overlaps auth + bundle parse + the VT
  // server compute — finishing before the first parse needs it. Warming the full
  // pool (not one worker) means the /shipments VT fan-out parses in parallel
  // across already-warm workers instead of serializing on a single one (ported
  // from dashmart; see MAX_PARQUET_WORKERS in parquet-worker-manager).
  useEffect(() => {
    parquetWorkerManager.warm();
  }, []);

  return (
    <ThemeModeProvider>
      <AuthProvider>
        <CustomerProvider>
          <RunProvider>
            <AppProvider>
              <SystemMessagesProvider>
                <ActivityLogging />
                <Outlet />
                <SystemMessages />
              </SystemMessagesProvider>
            </AppProvider>
          </RunProvider>
        </CustomerProvider>
      </AuthProvider>
    </ThemeModeProvider>
  );
}

export default App;
